export const environment = {
  api: 'https://gastosmedicosmenoresqa.kof.com/v1/api/',//'https://gastosmedicosmenoresqa.kof.com/api/',//'https://apim-gastmedmenqa01.azure-api.net/api/',
  version: '1.0.0',
  msalConfig: {
    auth: {
      clientId: '0132e277-ae8c-4a81-b153-ccb1dc734d72',
      authority: 'https://login.microsoftonline.com/7094d542-3815-4c82-b1d5-6917d0443cf4',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  key: '9eff8af3802b44c29746dfdea272d690',
}
